// SalonVIP tema tanımları. Her tema index.css'teki bir data-theme paletiyle eşleşir.
// minLevel: paketin bu temayı açması için gereken seviye (Bronze=1, Silver=2,
// Gold=3). Temel iki tema tüm paketlerde açık; premium üç tema yalnızca Gold'da.
// chart: recharts grafiklerinin temaya uyan renk paleti (hex string'ler).

export const THEMES = [
  {
    id: "light",
    name: "SalonVIP Light",
    description: "Mevcut aydınlık kimlik; ferah ve nötr.",
    minLevel: 1,
    swatch: ["#7c3aed", "#ec4899", "#f8f9ff", "#0b1c30"],
    chart: {
      primary: "#7c3aed",
      success: "#10b981",
      error: "#ef4444",
      gold: "#fbbf24",
      muted: "#4a4455",
      grid: "#ccc3d8",
      pie: ["#7c3aed", "#10b981", "#fbbf24", "#ef4444", "#3b82f6", "#ec4899", "#14b8a6", "#f97316"],
    },
  },
  {
    id: "dark",
    name: "SalonVIP Dark",
    description: "Yumuşak slate tonlu, gözü yormayan gece teması.",
    minLevel: 1,
    swatch: ["#a78bfa", "#f472b6", "#1e212b", "#e2e6f0"],
    chart: {
      primary: "#a78bfa",
      success: "#34d399",
      error: "#f87171",
      gold: "#fbbf24",
      muted: "#a2a8b8",
      grid: "#374151",
      pie: ["#a78bfa", "#34d399", "#fbbf24", "#f87171", "#60a5fa", "#f472b6", "#2dd4bf", "#fb923c"],
    },
  },
  {
    id: "rose",
    name: "SalonVIP Rose",
    description: "Pudra pembe, rose gold ve lila tonlarıyla zarif, feminen premium.",
    minLevel: 3,
    premium: true,
    swatch: ["#c04f86", "#b06ab3", "#fdf5f8", "#3d2432"],
    chart: {
      primary: "#c04f86",
      success: "#59b39a",
      error: "#e06666",
      gold: "#d8a25e",
      muted: "#7a5a68",
      grid: "#ecd2de",
      pie: ["#c04f86", "#b06ab3", "#e8a0c0", "#9d6bd6", "#59b39a", "#d8a25e", "#e07a9f", "#8f6bbf"],
    },
  },
  {
    id: "luxe",
    name: "SalonVIP Luxe",
    description: "Siyah/antrasit, altın ve şampanya tonlarıyla lüks, VIP salon hissi.",
    minLevel: 3,
    premium: true,
    swatch: ["#c9a227", "#e6d3a3", "#14130f", "#f2ead6"],
    chart: {
      primary: "#c9a227",
      success: "#7fbf9a",
      error: "#d9776b",
      gold: "#e6d3a3",
      muted: "#b8ac8e",
      grid: "#423b2a",
      pie: ["#c9a227", "#e6d3a3", "#a8851b", "#7fbf9a", "#b8ac8e", "#d9b45b", "#8a7d5c", "#efdca8"],
    },
  },
  {
    id: "botanica",
    name: "SalonVIP Botanica",
    description: "Adaçayı yeşili, krem ve doğal tonlarla sakin spa/wellness teması.",
    minLevel: 3,
    premium: true,
    swatch: ["#5f8564", "#b98a5e", "#f6f7f1", "#26301f"],
    chart: {
      primary: "#5f8564",
      success: "#6a9f5f",
      error: "#ca6b52",
      gold: "#c9a24e",
      muted: "#5b6450",
      grid: "#cdd6bc",
      pie: ["#5f8564", "#b98a5e", "#8fae6f", "#c9a24e", "#6a9f5f", "#a9b98a", "#7d9b8e", "#d0b57a"],
    },
  },
];

export const DEFAULT_THEME = "light";

export const THEME_BY_ID = THEMES.reduce((acc, t) => {
  acc[t.id] = t;
  return acc;
}, {});

/** Verilen paket seviyesinde (null ise temel) açık temalar. */
export function availableThemes(packageLevel) {
  const level = packageLevel ?? 1;
  return THEMES.filter((t) => level >= t.minLevel);
}
